"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../");

var defaultAttrs = function defaultAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.Tools.applyDefaults({
    url: "",
    width: "33%",
    paddingTop: 4,
    paddingRight: 4,
    paddingBottom: 4,
    paddingLeft: 4
  }, attrs);
};

var _default = {
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Embed",
  label: "Embed",
  description: "Embed custom third party widgets, scripts and content.",
  // validation: Yup.object()
  defaultAttrs: defaultAttrs,
  generateContent: function generateContent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        parent = _ref.parent;

    var content = [{
      id: _.Tools.generateUUID(),
      type: "Embed",
      attrs: defaultAttrs(),
      content: []
    }];
    return [{
      id: _.Tools.generateUUID(),
      type: "Row",
      attrs: {
        width: "100%",
        paddingTop: 4,
        paddingRight: 4,
        paddingBottom: 4,
        paddingLeft: 4,
        allowChildren: false
      },
      content: content
    }];
  }
};
exports["default"] = _default;